import React, { FC } from "react"

import { IconBaseProps } from "./Base"
import Box from "../atoms/box/Box"

const HomeIcon: FC<IconBaseProps> = ({
  width = "100%",
  height = "100%",
  ...props
}) => {
  return (
    <Box {...props}>
      <svg
        role="img"
        aria-label="Home"
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M23.121 9.04763L15.536 1.46163C14.5973 0.525615 13.3257 0 12 0C10.6744 0 9.40277 0.525615 8.46401 1.46163L0.879012 9.04763C0.599438 9.32541 0.377782 9.65593 0.226895 10.02C0.0760072 10.3841 -0.0011104 10.7745 1.20795e-05 11.1686V20.9856C1.20795e-05 21.7813 0.316083 22.5443 0.878692 23.1069C1.4413 23.6696 2.20436 23.9856 3.00001 23.9856H21C21.7957 23.9856 22.5587 23.6696 23.1213 23.1069C23.6839 22.5443 24 21.7813 24 20.9856V11.1686C24.0011 10.7745 23.924 10.3841 23.7731 10.02C23.6222 9.65593 23.4006 9.32541 23.121 9.04763V9.04763ZM15 21.9856H9.00001V18.0516C9.00001 17.256 9.31608 16.4929 9.87869 15.9303C10.4413 15.3677 11.2044 15.0516 12 15.0516C12.7957 15.0516 13.5587 15.3677 14.1213 15.9303C14.6839 16.4929 15 17.256 15 18.0516V21.9856ZM22 20.9856C22 21.2508 21.8947 21.5052 21.7071 21.6927C21.5196 21.8803 21.2652 21.9856 21 21.9856H17V18.0516C17 16.7255 16.4732 15.4538 15.5355 14.5161C14.5979 13.5784 13.3261 13.0516 12 13.0516C10.6739 13.0516 9.40216 13.5784 8.46448 14.5161C7.5268 15.4538 7.00001 16.7255 7.00001 18.0516V21.9856H3.00001C2.7348 21.9856 2.48044 21.8803 2.29291 21.6927C2.10537 21.5052 2.00001 21.2508 2.00001 20.9856V11.1686C2.00094 10.9036 2.1062 10.6496 2.29301 10.4616L9.87801 2.87863C10.4417 2.31756 11.2047 2.00257 12 2.00257C12.7953 2.00257 13.5583 2.31756 14.122 2.87863L21.707 10.4646C21.8931 10.6519 21.9983 10.9046 22 11.1686V20.9856Z"
          fill="currentColor"
        />
      </svg>
    </Box>
  )
}

export default HomeIcon
